import { writable } from 'svelte/store';
export const closableInformElement = writable<HTMLElement | null>(null);
